import {Component, inject, OnInit} from '@angular/core'
import {ActivatedRoute, ParamMap} from '@angular/router'
import {
  FooterComponent,
  SpbAccessibleLinkDirective
} from '@sparbanken-syd/sparbanken-syd-theme'
import version from '../../assets/package.json'
import {environment} from '../../environments/environment'
import {HeaderComponent} from '../common/header/header.component'
import {HemnetService, IHemnetData} from '../services/hemnet.service'
import {CalculationComponent} from './calculation/calculation.component'
import {InputComponent} from './input/input.component'
import {ObjectInfoComponent} from './object-info/object-info.component'

interface ICalculator {
  /**
   * ? Why are we calculating this?
   */
  loanAmount: number

  /**
   * Down payment, should we calculate that?
   */
  downPayment: number

  /**
   * What we get from Hemnet or something we calculate?
   */
  expenses: number

  /**
   * The interest rate as we find it as a number.
   */
  interestRate: number

  /**
   * The fee of a Bostadsrätt, if any.
   */
  avgift: number

  /**
   * Do not blame me...
   */
  houseType: 'Villa' | 'Bostadsrätt' | 'Fritidshus'
}

@Component({
  selector: 'spb-hemnet',
  templateUrl: './hemnet.component.html',
  styleUrls: ['./hemnet.component.scss'],
  imports: [HeaderComponent, ObjectInfoComponent, InputComponent, CalculationComponent, FooterComponent, FooterComponent, SpbAccessibleLinkDirective]
})
export class HemnetComponent implements OnInit {
  public version = version.version
  public copyrightYears = `2020-${new Date().getFullYear()}`

  /**
   * The disclaimer text from rt-backend
   */
  public disclaimerText: string[] | undefined

  public utmTags: string = environment.utmTags

  public calculatorQuery = ''
  protected calculatorUrl = environment.calculatorUrl

  private readonly hemnetService = inject(HemnetService)
  private readonly route = inject(ActivatedRoute)


  ngOnInit(): void {
    this.route.queryParamMap.subscribe(
      {
        next: (params: ParamMap) => {
          const id = params.get('id')
          if (id) {
            this.hemnetService.getHemnetData(id)
          }
        }
      })

    this.hemnetService.hemnetData.subscribe({
      next: v => {
        this.disclaimerText = v.disclaimerText
        this.buildCalculatorQuery(v)
      }
    })


  }

  private buildCalculatorQuery(i: IHemnetData): void {
    const typeMap: Record<number, string> = {
      0: 'Villa',
      1: 'Fritidshus',
      2: 'Bostadsrätt'
    }
    /**
     * NONE = -1,
     *   VILLA = 0,
     *   FRITIDSHUS = 1,
     *   BOSTADSRATT = 2
     */

    const calculator: ICalculator = {
      avgift: i.fee,
      downPayment: i.downPayment,
      expenses: Math.round((i.runCost ?? 0) / 12),
      houseType: typeMap[i.type as number] as any,
      interestRate: i.interestRate,
      loanAmount: i.askingPrice
    }

    /**
     * {
     *     "hemnetId": "20246155",
     *     "askingPrice": 1995000,
     *     "type": 0,
     *     "fee": 0,
     *     "runCost": 39989,
     *     "area": 120,
     *     "year": 1973,
     *     "name": "Hagagatan 12",
     *     "image": "https://bilder.hemnet.se/images/itemgallery_cut/24/9f/249ff86c802f9d05b882addb1a1b68f6.jpg",
     *     "downPayment": 299250,
     *     "expectedPrice": 1995000,
     *     "interestRate": 5.42,
     *     "interestStartDate": 1705276800000
     * }
     */
    this.calculatorQuery = new URLSearchParams(calculator as any).toString()
  }
}
